require('./src/angular-embedplayer');
require('./src/directives/embedvideo');
require('./src/filters/videosettings');
require('./src/filters/whitelist');
module.exports = 'videosharing-embed';


//////////////////
// WEBPACK FOOTER
// ./~/ng-videosharing-embed/index.js
// module id = 289
// module chunks = 1